import { Button, Flex, Group, Text, TextInput } from '@mantine/core';
import { BalanceText } from '../../../components/balance-text';
import { CustomCalendar } from '../../../components/custom-calendar';
import { User } from '../../../models/user';

interface UseBankFormProps {
  useBankHourTotalHours: string;
  requestedHours: string;
  selectedDates: Date[];
  setSelectedDates: (dates: Date[]) => void;
  loading: boolean;
  handleUseBankHour: () => void;
  userInfo: User | undefined;
  canUserHours: boolean | undefined;
}

export function UseBankForm({
  selectedDates,
  useBankHourTotalHours,
  setSelectedDates,
  loading,
  handleUseBankHour,
  requestedHours,
  userInfo,
  canUserHours,
}: UseBankFormProps) {
  const hasDates = selectedDates.length > 0;
  const hint = !hasDates
    ? 'Selecione os dias da folga.'
    : canUserHours === false
    ? 'Saldo insuficiente para os dias selecionados.'
    : null;

  return (
    <Flex w="100%" direction="column" gap={18} justify="center">
      <CustomCalendar
        value={selectedDates}
        onChange={(dates) => setSelectedDates(dates)}
        firstDayOfWeek="sunday"
      />
      <TextInput
        disabled
        value={userInfo?.username ?? ''}
        label={'Funcionário'}
        description={'Funcionário que receberá a folga'}
      />
      <Flex direction={'column'}>
        <Text color={'dimmed'} size={'sm'}>
          Total de horas requisitadas
        </Text>
        <Text fw={'bold'}>{hasDates ? requestedHours : '--'}</Text>
      </Flex>
      <Flex direction={'column'}>
        <Text color={'dimmed'} size={'sm'}>
          Saldo disponível
        </Text>
        {hasDates && useBankHourTotalHours ? (
          <BalanceText value={useBankHourTotalHours} />
        ) : (
          <Text fw="bold">--</Text>
        )}
      </Flex>
      {hint && (
        <Text color="orange" size="sm">
          {hint}
        </Text>
      )}
      <Group position="right">
        <Button
          loading={loading}
          onClick={() => handleUseBankHour()}
          disabled={!hasDates || !canUserHours}
        >
          Usar horas
        </Button>
      </Group>
    </Flex>
  );
}
